var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9166 4.29297L27.61 4.29297C28.142 4.29297 28.4085 4.93618 28.0323 5.31238L20.5355 12.8091C20.3111 13.0335 19.9473 13.0335 19.7229 12.8091C19.4985 12.5847 19.4985 12.2209 19.7229 11.9965L26.261 5.45848C22.8727 5.6273 19.6702 7.09981 17.3333 9.58232C17.1158 9.81338 16.7521 9.82437 16.521 9.60686C16.29 9.38934 16.279 9.02569 16.4965 8.79462C19.2008 5.92184 22.9712 4.29297 26.9166 4.29297ZM10.5953 15.5081C10.8197 15.7325 10.8197 16.0963 10.5953 16.3207L5.95656 20.9594L6.62797 22.6897L8.35832 23.3611L12.997 18.7224C13.2214 18.498 13.5853 18.498 13.8096 18.7224C14.034 18.9468 14.034 19.3106 13.8096 19.535L9.52919 23.8155L10.6856 24.2642C10.9815 24.379 11.1282 24.7119 11.0134 25.0078C10.8986 25.3036 10.5658 25.4504 10.2699 25.3356L6.30752 23.7981L2.9809 27.1247C2.7565 27.3491 2.39269 27.3491 2.1683 27.1247C1.9439 26.9003 1.9439 26.5365 2.1683 26.3121L5.50582 22.9745L3.98212 19.0478C3.86733 18.7519 4.0141 18.4191 4.30995 18.3043C4.60579 18.1895 4.93869 18.3362 5.05349 18.6321L5.50222 19.7885L9.78269 15.5081C10.0071 15.2837 10.3709 15.2837 10.5953 15.5081Z",
    fill: "url(#paint0_linear_4157_19139)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20628 5.31238C1.83008 4.93618 2.09655 4.29297 2.62854 4.29297L3.32202 4.29297C7.26449 4.29297 11.0322 5.91942 13.7361 8.78825L25.1102 20.1624C25.3346 20.3868 25.3346 20.7506 25.1102 20.975C24.8858 21.1994 24.522 21.1994 24.2976 20.975L12.9113 9.58863L12.9053 9.58232C10.5684 7.09981 7.3659 5.6273 3.97758 5.45848L21.8958 23.3767C22.1202 23.6011 22.1202 23.9649 21.8958 24.1893C21.6714 24.4137 21.3076 24.4137 21.0832 24.1893L2.20628 5.31238Z",
    fill: "url(#paint1_linear_4157_19139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9286 18.3042C26.2244 18.419 26.3712 18.7519 26.2564 19.0478L24.4986 23.5778L19.9686 25.3356C19.6728 25.4504 19.3399 25.3036 19.2251 25.0077C19.1103 24.7119 19.257 24.379 19.5529 24.2642L23.6105 22.6897L25.185 18.6321C25.2998 18.3362 25.6327 18.1895 25.9286 18.3042Z",
    fill: "url(#paint2_linear_4157_19139)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0703 27.1247C27.8459 27.3491 27.4821 27.3491 27.2577 27.1247L23.7294 23.5964C23.505 23.372 23.505 23.0082 23.7294 22.7838C23.9538 22.5594 24.3176 22.5594 24.542 22.7838L28.0703 26.3121C28.2947 26.5365 28.2947 26.9003 28.0703 27.1247Z",
    fill: "url(#paint3_linear_4157_19139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4157_19139",
    x1: 2.89704,
    y1: -0.224888,
    x2: 34.0759,
    y2: 2.44562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4157_19139",
    x1: 2.89704,
    y1: -0.224888,
    x2: 34.0759,
    y2: 2.44562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4157_19139",
    x1: 2.89704,
    y1: -0.224888,
    x2: 34.0759,
    y2: 2.44562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4157_19139",
    x1: 2.89704,
    y1: -0.224888,
    x2: 34.0759,
    y2: 2.44562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177476,
    stopColor: "#BB85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E5E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTeam);
export default __webpack_public_path__ + "static/media/red_team.c0cc2fea74c2fc2eb912aa3756ffab5e.svg";
export { ForwardRef as ReactComponent };